export default {
    icon: "el-icon-s-ticket",
    title: "优惠券",
    name: "coupon",
    timestamp: 1709627778508006,
    bgColor: {
        title: "背景颜色",
        default: [
            {
                "item": "#F8F8F8"
            }
        ],
        color: [
            {
                item: "#F8F8F8"
            }
        ]
    },
    bgStyle: {
        title: "背景样式",
        name: "bgStyle",
        type: 0,
        list: [
            {
                val: "直角",
                icon: 'el-icon-edit-outline'
            },
            {
                val: "圆角",
                icon: 'el-icon-c-scale-to-original'
            }
        ]
    },
    prConfig: {
        title: "背景边距",
        val: 0,
        min: 0
    },
    themeColor: {
        title: "主题颜色",
        default: [
            {
                item: "#E93323"
            }
        ],
        color: [
            {
                item: "#E93323"
            }
        ]
    },
    mbConfig: {
        title: "页面间距",
        val: 0,
        min: 0
    },
    id: "id1709627778508006"
}